export const EXPERIENCE_PLAYER_BASE_URL =
  process.env.EXPERIENCE_PLAYER_BASE_URL ||
  `https://eplayer${process.env.SUBDOMAIN ?? '-np-dev'}.${process.env
    .HOST_DOMAIN ?? 'cfctest.org'}`

export const LOCAL_STORAGE_KEY = 'experiencePlayer_link'

/**
 * Builds a localStorage key scoped to a specific learn-site path so that each
 * page persists its own experience-player link, rather than sharing a single
 * global link across the whole site.
 *
 * @param {string} [path] - The site path to scope the key to (defaults to the
 *   current `window.location.pathname`).
 * @returns {string} The path-scoped storage key
 */
export const getLinkStorageKey = path => {
  const resolvedPath =
    (typeof path === 'string' && path) ||
    (typeof window !== 'undefined' && window?.location?.pathname) ||
    '/'

  return `${LOCAL_STORAGE_KEY}::${resolvedPath}`
}

export const POLL_INTERVAL_MS = 30000

export const DEFAULT_TTL_SECONDS = 86400
